import {get, ref, serverTimestamp, set, update} from "firebase/database";
import {database} from "../utils/firebase";
import {ADMIN_CONFIG_PATHS} from "../config/adminConfig";
import {lc_name_cfg} from "../static/lc_name_cfg";

const NAME_CONFIG_PATH = ADMIN_CONFIG_PATHS.nameConfig;
const NAME_REVIEW_QUEUE_PATH = ADMIN_CONFIG_PATHS.nameReviewQueue;

const sortByRecent = (entries) => [...entries].sort((a, b) => {
  const aTime = new Date(a.lastSeenAt || a.updatedAt || a.firstSeenAt || 0).getTime();
  const bTime = new Date(b.lastSeenAt || b.updatedAt || b.firstSeenAt || 0).getTime();
  return bTime - aTime;
});

const normalizeQueueEntries = (value) => {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return sortByRecent(value.filter(Boolean));
  }
  return sortByRecent(Object.entries(value).map(([id, entry]) => ({id, ...entry})));
};

const nameConfigService = {
  async loadNameConfig() {
    const snapshot = await get(ref(database, NAME_CONFIG_PATH));
    if (!snapshot.exists()) {
      return {lc_name_cfg};
    }
    const value = snapshot.val();
    if (value?.lc_name_cfg) {
      return value;
    }
    return {lc_name_cfg: value};
  },

  async saveNameConfig(uid, nameConfig) {
    const payload = {
      ...nameConfig,
      updatedAt: serverTimestamp(),
      updatedBy: uid,
    };
    await set(ref(database, NAME_CONFIG_PATH), payload);
    return payload;
  },

  async loadReviewQueue() {
    const snapshot = await get(ref(database, NAME_REVIEW_QUEUE_PATH));
    if (!snapshot.exists()) {
      return [];
    }
    return normalizeQueueEntries(snapshot.val());
  },

  async updateReviewEntry(entryId, patch) {
    await update(ref(database, `${NAME_REVIEW_QUEUE_PATH}/${entryId}`), patch);
  },
};

export default nameConfigService;
